import actions from "./actions";
import state from "./state";
import mutations from "./mutations";

const getters = {
  getIndividualStaffAwayList: (state) => state.items,
  getIndividualStaffAwayListPagination: (state) => state.pagination,
};

export default {
  actions,
  state,
  mutations,
  getters,
};
